export const popUpMotion = {
	hidden: {
		scale: 0,
		opacity: 0,
		transition: {
			duration: 0.75,
		},
	},
	show: {
		scale: 1,
		opacity: 1,
		transition: {
			duration: 0.5,
		},
	},
	exit: {
		scale: 0,
		opacity: 0,
		transition: {
			duration: 0.75,
		},
	},
};
